let _version: string | null = null;

export function resolveVersion(): string {
  if (_version !== null) return _version;

  const hash = window.location.hash;
  const match = hash.match(/[?&]dataVer=([^&]+)/);
  if (match) {
    _version = decodeURIComponent(match[1]);
    return _version;
  }

  _version = __DATA_VERSION__;
  return _version;
}
